import React from "react"
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

import CardPermissions from "./CardPermissions";
import useTabs from "../../../components/TabsBar/useTabs";
import {useWorkgroupQuery} from "../query";
import TabPanel from "../../../components/TabsBar/TabPanel";
import PanelInfo from "./PanelInfo";

import {Grid} from "@mui/material";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import TabsBar from "../../../components/TabsBar";
import MDBox from "../../../materialDashboard/components/MDBox";


const Workgroup = () => {
    const {t} = useTranslation(['workgroups']);
    const {workgroupId} = useParams();

    const workgroupQuery = useWorkgroupQuery(workgroupId);

    const tabs = useTabs({tabs: [
            {label: t("workgroup.tabs.info"), icon: "info"},
            {label: t("workgroup.tabs.permissions"), icon: "rule"},
        ]});

    if (workgroupQuery.isLoading) {
        return null;
    }

    const workgroup = workgroupQuery.data;

    return <MDBox px={2}>
        <Grid container>
            <Grid item xs={12} md={6}>
                <MDTypography variant="h3" fontWeight="medium" mb={1}>
                    {t("workgroup.title", {name: workgroup.name})}
                </MDTypography>
            </Grid>
            <Grid item xs={12} md={6}>
                <TabsBar {...tabs}/>
            </Grid>
        </Grid>
        <TabPanel value={tabs.tabValue} index={0}>
            <PanelInfo workgroup={workgroup}/>
        </TabPanel>
        <TabPanel value={tabs.tabValue} index={1}>
            <CardPermissions/>
        </TabPanel>
    </MDBox>
}

export default Workgroup;